var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartReservation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.38965 8.75L5.55859 13.7422C5.47446 13.9721 5.50823 14.2289 5.64844 14.4297C5.78868 14.6303 6.01794 14.7499 6.2627 14.75H9.94629L3.29785 22.5195L4.91602 17.7402C4.99339 17.5114 4.95527 17.2588 4.81445 17.0625C4.67357 16.8663 4.44661 16.75 4.20508 16.75H0.84668L3.43457 8.75H7.38965Z",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.998 14.75C15.77 15.0531 15.4085 15.25 15 15.25C14.5915 15.25 14.23 15.0531 14.002 14.75H15.998ZM15 0.75C15.1381 0.75 15.25 0.861929 15.25 1C15.25 1.00877 15.2498 1.01725 15.249 1.02539L15.1826 1.7002L15.8467 1.83398C17.7883 2.2261 19.25 3.94329 19.25 6C19.25 6.60801 19.3817 8.15992 19.7031 9.69043C19.8644 10.4582 20.0793 11.25 20.3623 11.9277C20.4072 12.0353 20.4565 12.1428 20.5078 12.25H9.49219C9.54354 12.1429 9.59279 12.0353 9.6377 11.9277C9.92071 11.25 10.1356 10.4582 10.2969 9.69043C10.6183 8.15993 10.75 6.60802 10.75 6C10.75 3.94331 12.2117 2.22611 14.1533 1.83398L14.8174 1.7002L14.751 1.02539C14.7502 1.01725 14.75 1.00878 14.75 1C14.75 0.861929 14.8619 0.75 15 0.75Z",
    stroke: "#121212",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartReservation);
export default __webpack_public_path__ + "static/media/smart-reservation.25e266eac5ca97abf71f9133d6a2ce96.svg";
export { ForwardRef as ReactComponent };